/**
 * Formatters and array helpers - org type conversion, findByKey, etc.
 */
import { orgIds } from 'enum/combobox';
import type { RoleAssignmentItem } from 'modules/account/types';

export const convertOrgType = (t: string) => (orgIds[t] ? orgIds[t] : t);

export const convertOrgTypeToOriginal = (orgType: string) => {
  switch (orgType) {
    case 'HVS':
      return 'system';
    case 'KHDN':
      return 'client';
    case 'CQQL':
      return 'govAgency';
    default:
      return '';
  }
};

export const findByKey = <T>(s: T[] = [], targetId: string, k: string = 'roleId') => {
  return s.find((item: T) => (item as Record<string, unknown>)[k] === targetId) || false;
};

export const findByOrgIdAndRoleId = (
  arr: RoleAssignmentItem[] = [],
  opCode: string,
  roleId: string
) => arr.find((item) => item.orgId === opCode && item.roleId === roleId);
